export const hasProductGift = (product) => {
  if (!product) return false;
  if (Array.isArray(product.giftProducts) && product.giftProducts.length > 0) {
    return true;
  }
  return Array.isArray(product.giftProductIds) && product.giftProductIds.length > 0;
};

export const hasFreeDelivery = (product) => {
  if (!product) return false;
  const { freeDelivery } = product;
  return freeDelivery === true || freeDelivery === 1 || freeDelivery === '1';
};

export const getProductGifts = (product) => {
  if (!product) return [];
  if (Array.isArray(product.giftProducts) && product.giftProducts.length > 0) {
    return product.giftProducts;
  }
  return [];
};

export const mapGiftItemsForCart = (product) => {
  const source = product?.giftProducts || product?.giftItems || [];
  if (!Array.isArray(source)) return [];

  return source.map((gift) => ({
    id: gift.id,
    title: gift.title,
    images: gift.images,
    article: gift.article,
  }));
};

export const expandCartForOrder = (cart = []) => cart.flatMap((item) => {
  const main = { ...item };
  delete main.giftItems;
  delete main.giftProducts;

  const gifts = (item.giftItems || []).map((gift) => ({
    ...gift,
    quantity: item.quantity,
    price: 0,
    isGift: true,
    parentId: item.id,
  }));

  return [main, ...gifts];
});
